<template>
  <div class="mean-values-panel">
    <!--<div class="mean-values-legends">
      <div class="label">
        <span class="circle all"></span>{{ mainGroup }} ({{ caseList.length }})
      </div>
      <div
        class="label"
        :class="{ disabled: !selectionList || selectionList.length === 0 }"
      >
        <span class="circle selection"></span>Selected
        {{ selectionList && "(" + selectionList.length + ")" }}
      </div>
    </div>-->
    <div class="results-values">
      <div class="results-header">
        <div class="value-block header">
          <div class="field-name">Group</div>
          <div class="group-all-value">
            <span class="circle all"></span>{{ mainGroup }} ({{ caseList.length }})
          </div>
          <div
            class="selection-value"
            v-if="selectionList && selectionList.length > 0"
          >
              <span class="circle selection"></span>Selected {{ selectionList && "(" + selectionList.length + ")" }}
          </div>
        </div>
      </div>
      <div class="results-scrollable">
        <div class="value-block" v-for="field in outputFields" :key="field">
          <div class="field-name">{{ field }}</div>
          <div class="group-all-value">
            {{ Number.parseFloat(mean(caseList, field)).toFixed(2) }} ±
            {{ Number.parseFloat(std(caseList, field)).toFixed(2) }}
          </div>
          <div
            class="selection-value"
            v-if="selectionList && selectionList.length > 0"
          >
            {{ Number.parseFloat(mean(selectionList, field)).toFixed(2) }} ±
            {{ Number.parseFloat(std(selectionList, field)).toFixed(2) }}
          </div>
        </div>
      </div>
    </div>
    <!--
      <div class="results-header result-line">
        <div class="line-label"></div>
        <div class="line-value" v-for="field in outputFields" :key="field">
          <div class="field-name">{{field}}</div>
        </div>
      </div>
      <div class="all-results-line result-line">
        <div class="line-value" v-for="field in outputFields" :key="field">
          {{Number.parseFloat(mean(caseList, field)).toFixed(2)}} ± {{Number.parseFloat(std(caseList, field)).toFixed(2)}}
        </div>
      </div>
      <div class="selected-results-line result-line">
        <template v-if="selectionList && selectionList.length > 0">
          <div class="line-value"  v-for="field in outputFields" :key="field">
            {{Number.parseFloat(mean(selectionList, field)).toFixed(2)}} ± {{Number.parseFloat(std(selectionList, field)).toFixed(2)}}
          </div>
        </template>
      </div>
    </div>
    -->
    <div class="histogram-contaier">
      <div class="histogram-options">
        <multi-select-component
          label="Histogram"
          mode="single"
          v-model="xAttr"
          :options="outputFields"
          :configurationOptions="{
            'allow-empty': false,
            'label-inside': false,
          }"
        />
        <!--<text-input label="Histogram bins" :value="histogramBins" @change="(val) => histogramBins= val"></text-input>-->
      </div>
      <div class="histogram-wrapper">
        <MeanValuesHistogram
          :data="caseList"
          :selectionData="selectionList"
          :xAttr="xAttr"
          :nBins="histogramBins"
        ></MeanValuesHistogram>
      </div>
    </div>
  </div>
</template>

<script>
import { std, mean } from '@/utils/Math'
import MeanValuesHistogram from '@/components/MeanValuesHistogram'
import MultiSelectComponent from '@/components/MultiSelectComponent'
import TextInput from '@/components/inputs/inputsTypes/TextInput'

export default {
  name: 'MeanValuesPanel',
  components: {MeanValuesHistogram, MultiSelectComponent, TextInput},
  props: ['caseList', 'selectionList', 'mainGroup'],
  data () {
    return {
      xAttr: this.caseList[0].scalars[0].name, //'LVEF',
      histogramBins: 20
    }
  },
  computed: {
    outputFields () {
      return this.caseList[0] && (this.caseList[0].scalars || []).map((d)=>d.name) || []
    }
  },
  methods: {
    mean(list, fieldName) {
      list = list.filter((c)=>c.scalars)
      let vals = list.map(c => c.scalars.find((d)=>d.name === fieldName).value)
      return mean(vals)
    },
    std(list, fieldName) {
      list = list.filter((c)=>c.scalars)
      let vals = list.map(c => c.scalars.find((d)=>d.name === fieldName).value)
      return std(vals)
    }
  }
}
</script>

<style lang="stylus" scoped>
.mean-values-panel
  background-color: $bright-gray
  color: #fff
  display: flex
  flex-direction: column
  padding: 15px

  // overflow: hidden; // Very important por los hijos con "widgetcontent mixin"
  .mean-values-legends
    align-items: center
    display: flex
    margin-bottom: 5px

    .label
      align-items: center
      display: flex
      m-font-size(12, 14)
      text-transform: capitalize

      &:not(:last-child)
        margin-right: 20px

      &.disabled
        opacity: 0.4

      .circle
        border-radius: 25%
        display: inline-block
        height: 12px
        margin-right: 7px
        width: 12px

        &.all
          background: $heather

        &.selection
          background: $royal-blue

  .results-values
    $margin = 1px
    display: flex
    margin-left: -($margin)
    margin-right: -($margin)
    .results-header
      display: flex
    .results-scrollable
      width 100%
      overflow auto
      display flex
      flex-wrap nowrap
      padding-bottom 10px
    .value-block
      //$percentage = percentage((1 / 6))
      // $margin = 10px
      $width = 100px //"calc(%s - %s * 2)" % ($percentage $margin)
      flex: 0 0 $width
      // flex: 0 0 percentage((1 / 6))
      margin: $margin

      &.header
        .group-all-value,
        .selection-value
          width 150px
          max-width 150px
          white-space nowrap
          text-overflow ellipsis
          overflow hidden
          text-align left
          font-weight $fw-semi-bold


      .field-name
        color: $gull-gray
        m-font-size(10, 12)
        margin-bottom: 2px
        text-transform: uppercase
        min-height 16px
        height 16px

      .group-all-value,
      .selection-value
        background-color: rgba($gull-gray, 0.1)
        border-radius: 2px
        m-font-size(14, 16)
        padding: 4px 6px
        text-align: center

      .group-all-value
        color: $titan-white

      .selection-value
        background-color: rgba($gull-gray, 0.2)
        color: $royal-blue
        margin-top: $margin * 4

  .histogram-contaier
    border-top: 1px solid #21242D
    // overflow: hidden; // Very important por los hijos con "widgetcontent mixin"
    display: flex
    flex: 1 1 auto
    flex-direction: column
    margin-top: 7px
    padding-top: 7px
    width: 100%

    .histogram-options
      display: flex
      flex-direction: column
      max-width: 200px
      padding-right: 20px

    .histogram-wrapper
      display: flex
      flex: 1 1 auto
      flex-direction: column
      overflow: hidden
      position: relative

      .values-histogram
        height: 100%
        position: absolute
        width: 100%
        // flex 0 0 100%
</style>